import React, { useEffect } from "react";

import { Link, useParams } from "react-router-dom";
import privateRequest from "../commonApi/CommonApi";
import { useState } from "react";
import Modal from 'react-modal';
import moment from "moment";

import ActionsComponent from "../ActionsComponent";
import Swal from "sweetalert2";
import API_CONFIG from "../commonApi/ApiConfig";

function JobDetails() {
  const { data } = useParams();

  const [jobData, setJobData] = useState();
  const [assign, setAssign] = useState();
  const [action, setAction] = useState();
  const [code, setCode] = useState();
  const [fixedComment, setFixedComment] = useState();
  const [jobCount, setJobCount] = useState(0);
  const [SpImages, setSpImages] = useState([])
  const [ShowModale, setShowModale] = useState(false);
  const [ModalImage, setModalImage] = useState("")

  let adminName = localStorage.getItem("AdminName");

  let id = data;

  const getImages = async (id) =>{
    try {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };
      
      fetch(`${API_CONFIG.JOB_IMAGE_UPLOAD}/${id}`, requestOptions)
        .then((response) => response.json())
        .then((result) => {console.log(result)
          setSpImages(result)
        })
        .catch((error) => console.error(error));
      
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Something went wrong",
      })
      
    }
  }

  useEffect(() => {

    if (jobData?.jobId) {
      getImages(jobData?.jobId)
      
    }
   
  }, [jobData])
  

  const getUsers = async () => {
    try {
      const response = await privateRequest.get(`jobs/getJobsById/${id}`);
      console.log("jobs", response?.data?.data?.jobs[0]);
      setJobData(response?.data?.data?.jobs[0]);
      setJobCount(response?.data?.data?.jobs[0]?.totalUniqueMobileNumbers);
    } catch (error) {
      console.error("Error fetching jobs", error);
    }
  };

  useEffect(() => {
    if (id) {
      getUsers();
    }
  }, [id]);

  let addresses = jobData?.userId?.address;
  function findAddressById(addressId) {
    const address = addresses?.find((addr) => addr?._id === addressId);
    return address ? address : "Address not found";
  }
  const foundAddress = findAddressById(jobData?.clientAddressId);

  let history = [];

  if (Array.isArray(jobData?.updateLogs)) {
    const combinedJobData = jobData.updateLogs.flatMap((item) => {
      let result = [];

      if (item.adminsLog) {
        if (
          item.adminsLog.action === "comment" ||
          item.adminsLog.action === "Jobnotes" ||
          item.adminsLog.action === "job_created" ||
          item.adminsLog.action === "close"
        ) {
          result.push({
            mobile: item.admins?.mobile,
            name: item.admins?.name,
            date: item.adminsLog.updatedAt,
            date2:item,
            reason: item.adminsLog.reason,
            role: item.admins?.role,
            action: item.adminsLog.action,
            SpName: item.adminsLog.SPName || "",
            email: item.admins?.email,
            
          });
        }
      } else if (
        item.clientsLog?.action === "job_created" ||
        item.clientsLog?.action === "close"
      ) {
        result.push({
          mobile: item.clients?.mobileNo,
          name: item.clients?.name,
          date2:item,
          date: item.clients.updatedAt,
          action: item.clientsLog.action,
          email: item.clients?.email,
          role: item.clients?.role,
        });
      }

      return result;
    });

    history.push(...combinedJobData);
  } else {
    console.error("jobData is not an array");
  }

  //  job created ,jobnotes ,jobcomment , jobclose

  const handleChildValue = (value) => {
    console.log("valueeee", value);
    if (value) {
      getUsers();
    }
  };

  const extractCommonPcatIds = (dataArray) => {
    const commonPcatIds = new Set();
    dataArray?.forEach((item) => {
      if (item?.PCatId && item?.PCatId !== undefined) {
        commonPcatIds.add(item?.PCatId);
      }
    });
    return Array.from(commonPcatIds);
  };
  const commonPcatIds = extractCommonPcatIds(jobData?.cart);
  console.log("commonPcatIds", commonPcatIds);

  const sortedData =
    jobData &&
    jobData?.updateLogs?.sort((a, b) => {
      return (
        new Date(
          b?.adminsLog?.updatedAt ||
            b?.providersLog?.updatedAt ||
            b?.clientsLog?.updatedAt
        ) -
        new Date(
          a?.adminsLog?.updatedAt ||
            a?.providersLog?.updatedAt ||
            a?.clientsLog?.updatedAt
        )
      );
    });

  let statusHistory = [];

  if (Array.isArray(sortedData)) {
    const combinedJobData = sortedData.flatMap((item) => {
      console.log("item in log", item);
      let result = [];

      if (
        item?.adminsLog?.action !== "comment" &&
        item?.adminsLog?.action !== "Jobnotes" &&
        item?.clientsLog?.action !== "job_created" &&
        item?.adminsLog?.action !== "job_created"
      ) {
        result.push(item);
      }

      return result;
    });

    statusHistory.push(...combinedJobData);
  } else {
    console.error("jobData is not an array");
  }

  console.log("statusHistory", statusHistory);
  return (
    <>
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex justify-content-between align-items-center flex-md-row mb-2">
                    <p className="lead d-flex align-items-center mb-0">
                      <span className="font-weight-bold mr-2">
                        Job ID : {jobData?.jobId}
                      </span>
                      {jobData?.jobStatus == 0 && (
                        <label className="badge badge-primary mb-0">
                          Schedule
                        </label>
                      )}
                      {jobData?.jobStatus == 1 && (
                        <label className="badge badge-primary mb-0">Open</label>
                      )}
                      {jobData?.jobStatus == 2 && (
                        <label className="badge badge-warning">
                          Start Journey
                        </label>
                      )}
                      {jobData?.jobStatus == 3 && (
                        <label className="badge badge-warning">
                          Stop Journey
                        </label>
                      )}
                      {jobData?.jobStatus == 4 && (
                        <label className="badge badge-primary mb-0 progressBtn">
                          Progress
                        </label>
                      )}
                      {jobData?.jobStatus == 5 && (
                        <label className="badge badge-primary mb-0 pauseBtn">
                          Pause
                        </label>
                      )}
                      {jobData?.jobStatus == 6 && (
                        <label className="badge badge-primary mb-0 progressBtn ">
                          Progress
                        </label>
                      )}
                      {jobData?.jobStatus == 7 && (
                        <label className="badge badge-primary mb-0 successBtn">
                          Closed
                        </label>
                      )}

                      {jobData?.jobStatus == 9 && (
                        <label className="badge badge-primary mb-0 pauseBtn">
                          Canceled
                        </label>
                      )}
                      {jobData?.jobStatus == 10 && (
                        <label className="badge badge-primary mb-0 pauseBtn">
                          Cancel IR
                        </label>
                      )}
                      {jobData?.jobStatus == 11 && (
                        <label className="badge badge-primary mb-0 pauseBtn">
                          Cancel CR
                        </label>
                      )}
                      {jobData?.jobStatus == 12 && (
                        <label className="badge badge-primary mb-0 pauseBtn">
                          Cancel NR
                        </label>
                      )}
                    </p>
                    <div className="ml-auto">
                      <button
                        type="button"
                        className="btn btn-secondary"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        Action
                      </button>
                      <div className="dropdown-menu dropdown-menu-right leadjobMenus">
                        {/* If job is canceled (status 9, 10, 11, 12), show only Duplicate Job */}
                        {(jobData?.jobStatus === 9 ||
                          jobData?.jobStatus === 10 ||
                          jobData?.jobStatus === 11 ||
                          jobData?.jobStatus === 12) ? (
                          <div className="custom-control">
                            <Link
                              className="text-dark"
                              target="_blank"
                              to={`/duplicatejob/${jobData?.jobId}`}
                            >
                              <i className="fas fa-clone"></i> Duplicate Job
                            </Link>
                          </div>
                        ) : (
                          <>
                            {/* All other actions for non-canceled jobs */}
                            {jobData?.jobStatus != 7 && (
                              <>
                                {jobData?.jobStatus == 0 ? (
                                  <div className="custom-control">
                                    <span
                                      role="button"
                                      data-toggle="modal"
                                      data-target="#ressignSPModal"
                                      class="d-block"
                                      onClick={(e) => {
                                        setAssign("Assign");
                                        // getServiceProviderData();
                                      }}
                                    >
                                      <i class="fas fa-bullseye"></i> Assign SP
                                    </span>
                                  </div>
                                ) : (
                                  <div className="custom-control">
                                    <span
                                      role="button"
                                      data-toggle="modal"
                                      data-target="#ressignSPModal"
                                      class="d-block"
                                      onClick={(e) => {
                                        setAssign("Reassign");
                                      }}
                                    >
                                      <i class="fas fa-bullseye"></i> Reassign SP
                                    </span>
                                  </div>
                                )}
                              </>
                            )}

                            {jobData?.jobStatus == 3 && (
                              <div className="custom-control">
                                <span
                                  onClick={() => {
                                    setAction("Do You Want To Start Job");
                                    setCode("start_job");
                                    setFixedComment("start job by");
                                  }}
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                >
                                  <i className="fas fa-play-circle mr-1"></i>
                                  Start Job
                                </span>
                              </div>
                            )}

                            {jobData?.jobStatus == 1 && (
                              <div className="custom-control">
                                <span
                                  onClick={() => {
                                    setAction("Do You Want To Start Journey");
                                    setCode("start_journey");
                                    setFixedComment("start journey by");
                                  }}
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                >
                                  <i className="fas fa-bullseye mr-1"></i>
                                  Start Journey
                                </span>
                              </div>
                            )}
                            {jobData?.jobStatus == 2 && (
                              <div className="custom-control">
                                <span
                                  onClick={() => {
                                    setAction("Do You Want To Stop Journey");
                                    setCode("stop_journey");
                                    setFixedComment("stop journey by");
                                  }}
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                >
                                  <i className="fas fa-bullseye mr-1"></i>
                                  Stop Journey
                                </span>
                              </div>
                            )}
                            {jobData?.jobStatus == 4 || jobData?.jobStatus == 6 ? (
                              <div className="custom-control">
                                <span
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                  onClick={() => {
                                    setAction("Do You Want To Stop Job");
                                    setCode("stop_job");
                                    setFixedComment("stop job by");
                                  }}
                                >
                                  <i className="fas fa-pause-circle mr-1"></i>
                                  Pause Job
                                </span>
                              </div>
                            ) : null}

                            {jobData?.jobStatus == 5 && (
                              <div className="custom-control">
                                <span
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                  onClick={() => {
                                    setAction("Do You Want To Resume Job");
                                    setCode("resume_job");
                                    setFixedComment("resume job by");
                                  }}
                                >
                                  <i className="fas fa-play-circle mr-1"></i>
                                  Resume Job
                                </span>
                              </div>
                            )}
                            {jobData?.jobStatus != 7 && (
                              <div className="custom-control">
                                <Link
                                  className="text-dark"
                                  target="_blank"
                                  to={`/editjob/${jobData?.jobId}`}
                                >
                                  <i className="fas fa-edit"></i> Edit Job
                                </Link>
                              </div>
                            )}
                            <div className="custom-control">
                              <Link
                                className="text-dark"
                                target="_blank"
                                to={`/duplicatejob/${jobData?.jobId}`}
                              >
                                <i className="fas fa-clone"></i> Duplicate Job
                              </Link>
                            </div>
                            <div className="custom-control">
                              <span
                                role="button"
                                data-toggle="modal"
                                className="d-block"
                                data-target="#resheduleJobModal"
                              >
                                <i className="fa fa-user-edit mr-1"></i>
                                Reschedule
                              </span>
                            </div>

                            {/* {jobData?.jobStatus != 0 ||
                              (7 && (
                                <div className="custom-control">
                                  <span
                                    role="button"
                                    data-toggle="modal"
                                    className="d-block"
                                    data-target="#closeJobModal"
                                    // onClick={()}
                                  >
                                    <i className="fas fa-ban mr-1"></i>Close Job
                                  </span>
                                </div>
                              ))} */}
                            {jobData?.jobStatus !== 0 &&
                              jobData?.jobStatus !== 7 && (
                                <div className="custom-control">
                                  <span
                                    role="button"
                                    data-toggle="modal"
                                    className="d-block"
                                    data-target="#closeJobModal"
                                    // onClick={()}
                                  >
                                    <i className="fas fa-ban mr-1"></i>Close Job
                                  </span>
                                </div>
                              )}

                            {jobData?.jobStatus === 7 && (
                              <div className="custom-control">
                                <span
                                  role="button"
                                  data-toggle="modal"
                                  data-target="#yesNoactionModal"
                                  onClick={() => {
                                    setAction("Do You Want To Reopen Job");
                                    setCode("reopen");
                                    setFixedComment("reopen job by");
                                  }}
                                >
                                  <i className="fas fa-lock-open mr-1"></i>
                                  Reopen
                                </span>
                              </div>
                            )}

                            {jobData?.jobStatus != 7 && (
                              <div className="custom-control">
                                <span
                                  role="button"
                                  data-toggle="modal"
                                  className="d-block"
                                  data-target="#CancelJobModal"
                                >
                                  <i className="fas fa-window-close mr-1"></i>
                                  Cancel Job
                                </span>
                              </div>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="btn-group">
                    <button
                      className="btn btn-warning btn-sm px-3"
                      type="button"
                      data-toggle="modal"
                      data-target="#JobComment"
                      onClick={() => {
                        setAction("");
                        setFixedComment("");
                      }}
                    >
                      <i className="fa fa-comment mr-2"></i>
                      <span className="d-none d-lg-inline-block">
                        Add Comment
                      </span>
                    </button>
                    {/* <button
                      className="btn btn-danger btn-sm  px-3"
                      type="button"
                      data-toggle="modal"
                      data-target="#JobPenalty"
                    >
                      <i className="fa fa-credit-card mr-2"></i>
                      <span className="d-none d-lg-inline-block">
                        Add Penalty
                      </span>
                    </button> */}
                    <button
                      className="btn btn-info btn-sm  px-3"
                      type="button"
                      data-toggle="modal"
                      data-target="#spNote"
                    >
                      <i className="fa fa-sticky-note mr-2"></i>
                      <span className="d-none d-lg-inline-block">Add Note</span>
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card" style={{ borderRadius: "15px" }}>
                    <div className="card-header py-0">
                      <div className="nav-scroller">
                        <ul className="nav nav-tabs">
                          <li className="nav-item">
                            <a
                              className="nav-link show active"
                              data-toggle="tab"
                              href="#cstmr_info"
                            >
                              Customer Info
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#cstmr_logs"
                            >
                              History
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#cstmr_history"
                            >
                              Status History
                            </a>
                          </li>
                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#cstmr_carthistory"
                            >
                              Cart History
                            </a>
                          </li>

                          <li className="nav-item">
                            <a
                              className="nav-link"
                              data-toggle="tab"
                              href="#sp_image"
                            >
                              Sp Image
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="card-body">
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="tab-content" id="clientDetailsTabs">
                            <div
                              className="tab-pane fade active show"
                              id="cstmr_info"
                              role="tabpanel"
                              aria-labelledby="client-billing-contact-tab"
                            >
                              <div className="row">
                                <div className="col-lg-4">
                                  <div
                                    className="card card-fluid"
                                    style={{
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="card-body py-2 mb-0 bg-primary">
                                      <h3 className="text-white card-title mb-0">
                                        Lead Info
                                      </h3>
                                    </div>
                                    <hr className="my-0" />
                                    <div className="list-group list-group-bordered list-group-reflow">
                                      <div className="list-group-item justify-content-between align-items-center py-1 py-1">
                                        <span>
                                          <b>Name</b>
                                        </span>
                                        <span className="text-dark text-capitalize">
                                          {jobData?.userId?.name}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Email</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData?.userId?.email}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Contact No</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData?.userId?.mobileNo}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span
                                          style={{ width: "100px" }}
                                          className="mr-3"
                                        >
                                          <b>Address</b>
                                        </span>
                                        <span className="text-dark text-right">
                                          {/* {foundAddress} */}
                                          {foundAddress?.houseOrFlatNo},
                                          {foundAddress?.buildingName},{" "}
                                          {foundAddress?.landmark}
                                          {foundAddress?.FullAddress}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Source</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData?.jobsSource}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Customer Suggestions</b>
                                        </span>
                                        <span className="text-dark">
                                          {/* {jobData?.Note} */}
                                          {jobData?.Note || jobData?.Jobnotes}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div
                                    className="card card-fluid"
                                    style={{
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="card-body py-2 mb-0z bg-primary">
                                      <h3 className="text-white card-title mb-0">
                                        Other Details
                                      </h3>
                                    </div>
                                    <div className="list-group list-group-bordered list-group-reflow">
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Shedule Date</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData &&
                                            jobData?.slotDate?.slice(0, 10)}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Time Slot</b>
                                        </span>
                                        <span className="text-dark">
                                          <span
                                            className="badge badge-primary"
                                            style={{ fontSize: "14px" }}
                                          >
                                            {jobData?.slotTime}
                                          </span>
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Category Group</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData?.cart[0]?.PCGroup?.PCGName
                                            ? jobData?.cart[0]?.PCGroup?.PCGName
                                            : ""}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Job Count</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobCount}
                                        </span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Total Jobs in Group </b>
                                        </span>
                                        <span className="text-dark">2</span>
                                      </div>
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Assign To</b>
                                        </span>
                                        <span
                                          style={{
                                            fontSize: "14px",
                                          }}
                                          className="font-weight-bolder badge badge-primary px-2 text-white"
                                        >
                                          {jobData?.jobAssignSProviderId?.Name}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-4">
                                  <div
                                    className="card card-fluid"
                                    style={{
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="card-body py-2 mb-0z bg-primary">
                                      <h3 className="text-white card-title mb-0">
                                        Transcation Details
                                      </h3>
                                    </div>
                                    <hr className="my-0" />
                                    <div className="list-group list-group-bordered list-group-reflow">
                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Sub Total :</b>
                                        </span>
                                        <span className="text-dark font-weight-bolder">
                                          <del>₹{jobData?.RPrice}</del> ₹
                                          {jobData?.SPrice}
                                        </span>
                                      </div>
                                      {parseFloat(jobData?.concession) > 0 && (
                                        <div className="list-group-item justify-content-between align-items-center py-2">
                                          <span>
                                            <b>Concession :</b>
                                          </span>
                                          <span className="text-danger font-weight-bolder">
                                            -₹ {jobData?.concession}
                                          </span>
                                        </div>
                                      )}
                                      {parseFloat(jobData?.surgeCharges) >
                                        0 && (
                                        <div className="list-group-item justify-content-between align-items-center py-2">
                                          <span>
                                            <b>Surge Charges :</b>
                                          </span>
                                          <span className="font-weight-bolder">
                                            ₹ {jobData?.surgeCharges}
                                          </span>
                                        </div>
                                      )}
                                      {/* WalletDataChekAmaunt */}
                                      
                                      {parseFloat(jobData?.WalletDataChekAmaunt) >
                                        0 && (
                                        <div className="list-group-item justify-content-between align-items-center py-2">
                                          <span>
                                            <b>Wallet :</b>
                                          </span>
                                          <span className="text-dark font-weight-bolder">
                                            - ₹ {jobData?.WalletDataChekAmaunt}
                                          </span>
                                        </div>
                                      )}
                                      {parseFloat(jobData?.couponDiscount) >
                                        0 && (
                                        <div className="list-group-item justify-content-between align-items-center py-2">
                                          <span>
                                            <b>
                                              Coupon Code :{" "}
                                              {jobData?.couponCode}
                                            </b>
                                          </span>
                                          <span className="text-danger font-weight-bolder">
                                            - ₹ {jobData?.couponDiscount}
                                          </span>
                                        </div>
                                      )}
                                      {jobData &&
                                        jobData?.otherCharges?.map(
                                          (item, index) => {
                                            return (
                                              <div className="list-group-item justify-content-between align-items-center py-2">
                                                <span>
                                                  <b>{item?.charge}:</b>
                                                </span>
                                                <span className="text-dark font-weight-bolder">
                                                  ₹ {item?.price}
                                                </span>
                                              </div>
                                            );
                                          }
                                        )}

                                      {jobData?.tip > 0 && (
                                        <div className="list-group-item justify-content-between align-items-center py-1">
                                          <span>
                                            <b>Tip :</b>
                                          </span>
                                          <span className="text-dark font-weight-bolder">
                                            ₹ {jobData?.tip}
                                          </span>
                                        </div>
                                      )}
                                      <div className="list-group-item justify-content-between align-items-center py-2">
                                        <span>
                                          <b>Payble Amount (Including GST)</b>
                                        </span>
                                        <span className="text-dark ml-auto font-weight-bolder">
                                          ₹ {jobData?.payableCharges}
                                        </span>
                                      </div>

                                      <div className="list-group-item justify-content-between align-items-center py-1">
                                        <span>
                                          <b>Payment Mode :</b>
                                        </span>
                                        <span className="text-dark">
                                          {jobData?.payment_Mode}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div
                                    className="card"
                                    style={{
                                      borderRadius: "10px",
                                      overflow: "hidden",
                                    }}
                                  >
                                    <div className="card-header">
                                      <h4 className="card-title mb-0 d-flex justify-content-between align-items-center ">
                                        Cart Info
                                        <span className="font-weight-normal">
                                          Total Time ({jobData?.TServiceTiming}{" "}
                                          min)
                                        </span>
                                      </h4>
                                    </div>
                                    <div className="card-body">
                                      <table className="table table-sm table-bordered">
                                        <thead>
                                          <tr>
                                            <th>SN</th>
                                            <th>Service</th>
                                            <th>Qty</th>
                                            <th>Rate</th>
                                            <th>Total</th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {jobData?.cart?.map((item, index) => {
                                            return (
                                              <tr>
                                                <td>{index + 1}</td>
                                                <td>
                                                  <span
                                                    style={{
                                                      fontSize: "15px",
                                                      fontWeight: 600,
                                                    }}
                                                  >
                                                    {item?.packageTitle}
                                                  </span>
                                                  <ul
                                                    className="ml-1"
                                                    style={{
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {item?.packageName &&
                                                      item?.packageName.map(
                                                        (item, index) => {
                                                          return (
                                                            <li className="mb-0">
                                                              {item}
                                                            </li>
                                                          );
                                                        }
                                                      )}
                                                  </ul>
                                                </td>
                                                <td>{item?.Quantity}</td>
                                                <td>
                                                  ₹ {item?.packagetotalPrice}
                                                </td>
                                                <td>₹ {item?.Amount}</td>
                                              </tr>
                                            );
                                          })}
                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="cstmr_logs"
                              role="tabpanel"
                              aria-labelledby="client-billing-contact-tab"
                            >
                              {/* <table className="table table-sm table-striped">
                                <thead>
                                  <tr>
                                    <th>User id</th>
                                    <th>Posted By</th>
                                    <th>Comment</th>
                                    <th>Date Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {history &&
                                    history?.map((item, index) => {
                                      let role =
                                        (item?.updatedBy?.role == 0 &&
                                          "Admin") ||
                                        (item?.updatedBy?.role == 1 && "SP") ||
                                        (item?.updatedBy?.role == 2 && "User");

                                      return (
                                        <tr>
                                          <td>
                                            {item?.updatedBy?.mobile}

                                            <p className="mb-0">({role})</p>
                                          </td>
                                          <td>
                                            {item?.updatedBy?.name}
                                            <p className="mb-0">{item?.updatedBy?.email}</p>
                                          </td>
                                          <td>
                                            <b className="text-capitalize">
                                              {item?.action?.replace(/_/g, " ")}{" "}
                                              By {item?.updatedBy?.name}{" "}
                                            </b>
                                            <p className="mb-0">{item?.reason}</p>
                                          </td>
                                          <td>
                                            {item?.updatedAt?.slice(0, 10)} (
                                            {item?.updatedAt?.slice(11, 16)})
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table> */}
                              <table className="table table-sm table-striped">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <th>SN</th>
                                    <th>User</th>
                                    <th>Posted By</th>
                                    <th>Comment</th>
                                    <th>Date & Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {history &&
                                    history.map((item, index) => {
                                      function convertUTCToIST(utcDate) {
                                        const date = new Date(utcDate);
                                        date.setHours(date.getHours() + 5);
                                        date.setMinutes(date.getMinutes() + 30);
                                        return date;
                                      }

                                      // Assuming item?.date is the date string in ISO 8601 format
                                      const utcDate = item?.date;
                                      const istDate = convertUTCToIST(utcDate);

                                      // Format the IST date back to the required format
                                      const datePart = istDate
                                        .toISOString()
                                        .slice(0, 10);
                                      const timePart = istDate
                                        .toISOString()
                                        .slice(11, 16);

                                      console.log("history", item);
                                      let role = "";
                                      if (
                                        item?.role === 0 ||
                                        item?.role === 1
                                      ) {
                                        role = "Admin";
                                      } else if (item?.role === 3) {
                                        role = "SP";
                                      } else if (item?.role === 2) {
                                        role = "clients";
                                      }

                                      let MyRole;
                                      if (role === "Admin") {
                                        MyRole = "Admin";
                                      } else if (role === "SP") {
                                        MyRole = "SP";
                                      } else if (role === "clients") {
                                        MyRole = "clients";
                                      } else {
                                        MyRole = "Unknown"; // Default case handling
                                      }
                                      console.log("item andar log ke", item);

                                      return (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <p className="mb-0 font-weight-bolder">
                                              {MyRole}
                                            </p>
                                            <p className="mb-0">
                                              {item?.mobile}
                                            </p>
                                            <p className="mb-0">
                                              {item?.email}
                                            </p>
                                          </td>

                                          <td>{item?.name}</td>
                                          <td>
                                            <b className="text-capitalize">
                                              {item?.action?.replace(/_/g, " ")}{" "}
                                              {item?.action == "assigned" ||
                                              item?.action == "reassigned"
                                                ? "To "
                                                : "By "}
                                              {item?.action == "assigned" ||
                                              item?.action == "reassigned"
                                                ? item?.SpName
                                                : item?.name}
                                            </b>
                                            <p className="mb-0">
                                              {item?.reason}
                                            </p>
                                          </td>
                                          <td>
                                            {item?.date2?.clientsLog?.updatedAt ? (
                                              <>
                                                {moment(item?.date2?.clientsLog?.updatedAt).format('YYYY-MM-DD')} &nbsp;&nbsp; {moment(item?.date2?.clientsLog?.updatedAt).format('hh:mm A')}
                                              </>
                                            ) : null}
                                          </td>
                                          {/* <td>
                                            {item?.date?.slice(0, 10)}{" "}
                                            &nbsp;&nbsp;
                                            {item?.date?.slice(11, 16)}
                                          </td> */}
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="cstmr_history"
                              role="tabpanel"
                              aria-labelledby="client-billing-contact-tab"
                            >
                              <table className="table table-sm table-hover table-striped">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <th>SN</th>
                                    <th>User</th>
                                    <th>Posted By</th>
                                    <th>Actions</th>
                                    <th>Status History</th>
                                    <th>Date & Time</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {statusHistory &&
                                    statusHistory?.map((item, index) => {
                                      console.log(
                                        "itm in status history",
                                        item
                                      );
                                      function convertUTCToIST(utcDate) {
                                        const date = new Date(utcDate);
                                        date.setHours(date.getHours() + 5);
                                        date.setMinutes(date.getMinutes() + 30);
                                        return date;
                                      }

                                      // Assuming item?.date is the date string in ISO 8601 format

                                      // Format the IST date back to the required format

                                      let role;
                                      let innerArray;
                                      let innerLogArray;
                                      let MyRole;

                                      if (
                                        item?.admins?.role === 0 ||
                                        item?.admins?.role === 1
                                      ) {
                                        role = "Admin";
                                        MyRole = "Admin";
                                        innerArray = "admins";
                                        innerLogArray = "adminsLog";
                                      } else if (item?.provider?.role === 3) {
                                        role = "SP";
                                        MyRole = "SP";
                                        innerArray = "provider";
                                        innerLogArray = "providersLog";
                                      } else if (item?.clients?.role === 2) {
                                        role = "Client";
                                        MyRole = "Client";
                                        innerArray = "clients";
                                        innerLogArray = "clientsLog";
                                      } else {
                                        role = undefined;
                                        innerArray = undefined;
                                        innerLogArray = undefined;
                                      }
                                      const utcDate =
                                        item?.[innerLogArray]?.updatedAt;
                                      const istDate = convertUTCToIST(utcDate);
                                      const datePart = istDate
                                        .toISOString()
                                        .slice(0, 10);
                                      const timePart = istDate
                                        .toISOString()
                                        .slice(11, 16);

                                      console.log(
                                        "item?.[innerLogArray]",
                                        item?.[innerArray]?.name
                                      );
                                      return (
                                        <tr key={index}>
                                          <td>{index + 1}</td>
                                          <td>
                                            <p className="mb-0">{MyRole}</p>
                                            {item?.[innerArray]?.mobile ||
                                              item?.[innerArray]?.mobileNo ||
                                              item?.[innerArray]?.ContactNo}
                                          </td>
                                          <td>
                                            {item?.[innerArray]?.name ||
                                              item?.[innerArray]?.Name}
                                            <p className="mb-0">
                                              {item?.[innerArray]?.email ||
                                                item?.[innerArray]?.Emailid}
                                            </p>
                                          </td>
                                          <td>
                                            {item?.[
                                              innerLogArray
                                            ]?.action?.replace(/_/g, " ")}
                                          </td>

                                          <td>
                                            {item?.[innerLogArray]?.action ==
                                            "reschedule" ? (
                                              <>
                                                {item?.[innerLogArray]
                                                  ?.SPName &&
                                                  " Assigned to  " +
                                                    item?.[innerLogArray]
                                                      ?.SPName}
                                                <p className="">
                                                  {item?.[innerLogArray]
                                                    ?.action === "reschedule" &&
                                                    item?.[innerLogArray]
                                                      ?.previousSlotDate}
                                                  <span className="badge badge-primary ml-2">
                                                    {item?.[innerLogArray]
                                                      ?.action ===
                                                      "reschedule" &&
                                                      item?.[innerLogArray]
                                                        ?.previousSlotTime}
                                                  </span>
                                                  <span className="mx-3 font-weight-bolder">
                                                    To
                                                  </span>

                                                  {jobData?.slotDate}
                                                  <span className="badge badge-primary ml-2">
                                                    {jobData?.slotTime}
                                                  </span>
                                                </p>
                                              </>
                                            ) : (
                                              // <b className="text-capitalize">
                                              //   {item?.[innerLogArray]
                                              //     ?.action === "reassigned" &&
                                              //     "From "}
                                              //   {item?.[innerLogArray]
                                              //     ?.action === "assigned" &&
                                              //     "To "}
                                              //   {item?.[innerLogArray]
                                              //     ?.action === "reassigned" &&
                                              //     item?.[innerLogArray]
                                              //       ?.previousJobAssignSProviderId
                                              //       ?.Name}

                                              //   {item?.[innerLogArray]
                                              //     ?.action === "reassigned" &&
                                              //     "To "}

                                              //   {item?.[innerArray]?.name}
                                              // </b>
                                              <b className="text-capitalize">
                                                {item?.[innerLogArray]
                                                  ?.action === "reassigned" && (
                                                  <>
                                                    {item?.[innerLogArray]
                                                      ?.previousJobAssignSProviderId
                                                      ?.Name
                                                      ? `From ${item?.[innerLogArray]?.previousJobAssignSProviderId?.Name} `
                                                      : ""}{" "}
                                                    {!jobData?.jobAssignSProviderId ==
                                                      null &&
                                                      "To" +
                                                        item?.[innerArray]
                                                          ?.name}
                                                    {!item?.[innerLogArray]
                                                      ?.SPName &&
                                                      "To" + " Blank"}
                                                  </>
                                                )}
                                                {item?.[innerLogArray]
                                                  ?.action === "assigned" ||
                                                item?.[innerLogArray]?.SPName
                                                  ? `To ${item?.[innerLogArray]?.SPName}`
                                                  : ""}
                                              </b>
                                            )}

                                            <p className="mb-0">
                                              {item?.[innerLogArray]?.action !=
                                                "close" &&
                                                item?.[innerLogArray]?.reason}
                                            </p>
                                          </td>

                                          <td>
                                            {datePart} &nbsp; &nbsp;
                                            {timePart}
                                          </td>
                                        </tr>
                                      );
                                    })}
                                </tbody>
                              </table>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="cstmr_carthistory"
                              role="tabpanel"
                              aria-labelledby="client-billing-contact-tab"
                            >
                              <table className="table table-sm table-hover table-striped">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <th>SN</th>
                                    <th>Posted By</th>
                                    <th>Log Type</th>
                                    <th>Comment</th>
                                    <th>Date/Time</th>
                                  </tr>
                                </thead>
                                <tbody></tbody>
                              </table>
                            </div>

                            <div
                              className="tab-pane fade"
                              id="sp_image"
                              role="tabpanel"
                              aria-labelledby="client-billing-contact-tab"

                            >
                              <table className="table table-sm table-hover table-striped">
                                <thead className="bg-primary text-white">
                                  <tr>
                                    <th>SN</th>
                                    <th>Posted By</th>
                                    <th>Image</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {SpImages?.map((item, index) => {
                                    return(
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item?.SPName}</td>
                                        <td><img onClick={() => {setModalImage(`${API_CONFIG.IMAGE_URL}${item?.Image}`); setShowModale(true)}} className="" style={{height:"100px",width:"100px"}} src={`${API_CONFIG.IMAGE_URL}${item?.Image}`} alt="" />
                                        </td>
                                      </tr>
                                      
                                    )
                                  })}
                                </tbody>
                              </table>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal isOpen={ShowModale} onRequestClose={() => setShowModale(false)} style={{overlay:{zIndex:"99999999999999999999"}}}>
     <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"100%",height:"100%"}}>
      <div>
      <img src={ModalImage} alt="" style={{height:"500px",width:"500px",zIndex:"99999999999999999999"}} />
      <br></br>
      <button className="btn btn-primary mt-2" onClick={() => setShowModale(false)}>Close</button>
      </div>
     </div>
      </Modal>
      <ActionsComponent
        id={id}
        assign={assign}
        jobId={jobData?.jobId}
        amount={jobData?.payableCharges}
        tip={jobData?.tip || 0}
        action={action}
        adminName={adminName}
        fixedComment={fixedComment}
        code={code}
        actionsPass={handleChildValue}
        selectedGroup={jobData?.cart[0]?.PCGroup?._id}
        userId={jobData?.userId?._id}
      />
    </>
  );
}

export default JobDetails;
